import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { LabelMedium, LabelSmall } from 'baseui/typography';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { currentStateState } from '../../storage/client';
import { SecondaryDeviceDetail } from '../../types/device';
import { getSatellitesImage, getSignalImage } from '../../utils/currentStates';
import { BatteryPercentage } from '../shared/BatteryPercentage';
import { StyledTooltip } from '../ui/StyledTooltip';

type Props = {
  device: SecondaryDeviceDetail;
};

function MultipleDeviceCardHeader({ device }: Readonly<Props>) {
  const { theme, css, classes } = useStyles();
  const batteryPercentage = device.battery_percentage;
  const currentState = useRecoilValue(currentStateState(device.ident));
  const initialVehicleColor = currentState?.asset.vehicle?.color;

  return (
    <FlexRow
      classNames={css({
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme.sizing.scale500} ${theme.sizing.scale600}`,
      })}
    >
      <FlexRow
        gap={theme.sizing.scale200}
        classNames={classes.centeredStart}
      >
        <StyledTooltip content="Identificador">
          <LabelMedium
            className={css({
              paddingRight: theme.sizing.scale400,
              paddingLeft: theme.sizing.scale400,
              paddingTop: theme.sizing.scale100,
              paddingBottom: theme.sizing.scale100,
              backgroundColor: device.isPrimary ? initialVehicleColor ?? device.color : device.color,
              borderRadius: theme.sizing.scale600,
            })}
          >
            {device.ident}
          </LabelMedium>
        </StyledTooltip>
        {device.isPrimary && <LabelSmall color={theme.colors.contentTertiary}>- primario</LabelSmall>}
      </FlexRow>
      <FlexRow
        gap={theme.sizing.scale300}
        classNames={classes.centeredStart}
      >
        <StyledTooltip content="Satélites">
          <img
            src={getSatellitesImage(device.position_satellites)}
            alt=""
          />
        </StyledTooltip>
        <StyledTooltip content="Señal GSM">
          <img
            src={getSignalImage(device.gsm_signal_dbm)}
            alt=""
          />
        </StyledTooltip>
        <StyledTooltip content="Tipo de posición">
          <LabelSmall>{device.positionType}</LabelSmall>
        </StyledTooltip>
        <StyledTooltip content="Batería de Reserva">
          <BatteryPercentage percentage={batteryPercentage} />
        </StyledTooltip>
        <StyledTooltip content={device.engine_ignition_status ? 'Encendido' : 'Apagado'}>
          <MaterialIcon
            name="power_settings_new"
            warn={!device.engine_ignition_status}
            success={!!device.engine_ignition_status}
          />
        </StyledTooltip>
      </FlexRow>
    </FlexRow>
  );
}

export default memo(MultipleDeviceCardHeader);
